import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'What format does Soccer Ready™ come in?',
    a: 'PDF — downloadable instantly to any device (phone, tablet, laptop, computer).'
  }, {
    q: "I'm a first-time coach with no experience. Is this right for me?",
    a: 'Yes — in fact, it was built with coaches like you in mind. Everything is explained clearly with no assumed knowledge.'
  }, {
    q: 'What age groups does this cover?',
    a: 'Everything from U4 through U13 — every single age group has its own development roadmap and session plans.'
  }, {
    q: "I've coached for years. Will I find anything new here?",
    a: "Yes. Even experienced coaches tell us the organization and structure alone is worth the investment. 800+ pages of resources means you'll find drills and ideas you've never used."
  }, {
    q: 'Will this work for small teams or large squads?',
    a: 'Yes — the small-sided games and session plans are adaptable to any squad size.'
  }, {
    q: 'Is there a physical version?',
    a: 'Soccer Ready™ is a digital product only. This keeps it affordable and means you get it instantly.'
  }, {
    q: 'What if I want a refund?',
    a: "No problem. You have 7 days to try it. If you're not happy, we'll refund you in full — no questions asked."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-forest py-24 px-4 border-t border-white/5" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <h2 className="font-display text-4xl md:text-5xl text-white text-center mb-12 uppercase" data-id="element-73">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-74">
          {faqs.map((faq, index) => <div key={index} className={`bg-ink border rounded-lg overflow-hidden transition-colors ${openIndex === index ? 'border-brightGreen/50' : 'border-white/10 hover:border-white/20'}`} data-id="element-75">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-76">
                <span className="font-bold text-white pr-4" data-id="element-77">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${openIndex === index ? 'rotate-180 text-brightGreen' : ''}`} data-id="element-78" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-79">
                <p className="text-gray-300 leading-relaxed" data-id="element-80">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}